import { urls } from '@sendible/common';
import { useBridgeContext } from '@sendible/shared-state-bridge';

export const useServiceConnection = () => {
  const [{ user }] = useBridgeContext();

  const openConnectionWindow = (connectionUrl: string) => {
    window.open(connectionUrl, '_blank');
  };

  const connectToService = (serviceId: string) => {
    const connectionUrl = `${urls.baseUrl}/api/v2/connect?parent_domain=${encodeURIComponent(
      `${window.location.protocol}//${window.location.hostname}`
    )}&service_id=${serviceId}&pricingEnabled=true`;

    let urlWithContext = `${connectionUrl}&username=${user.username}&access_token=${user.accessToken}`;

    if (user.isSwitchedUser) {
      urlWithContext = `${connectionUrl}&username=${user.username}&logged_in_access_token=${user.accessToken}`;
    }
    openConnectionWindow(urlWithContext);
  };

  return { connectToService };
};
